if (!customElements.get('bf-terms-modal')) {
  customElements.define('bf-terms-modal', class extends HTMLElement {
    connectedCallback() {
      this.stopRotation?.();
      this.controller?.abort();
      this.stopScrollbar?.();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.bf-lucky-draw__terms-trigger');
      if (!dialog || !trigger) return;
      this.dialog = dialog;
      const scroll = dialog.querySelector('.bf-lucky-draw__terms-scroll');
      const scrollbar = dialog.querySelector('.bf-lucky-draw__terms-scrollbar');
      let updateScrollbar = () => {};
      if (scroll && scrollbar) {
        let frame = null;
        const renderScrollbar = () => {
          frame = null;
          if (!dialog.open) return;
          const range = scroll.scrollHeight - scroll.clientHeight;
          scrollbar.toggleAttribute('data-overflow', range > 0);
          const travel = Math.max(0, scrollbar.clientHeight - 177);
          const progress = range > 0 ? Math.min(1, Math.max(0, scroll.scrollTop / range)) : 0;
          scrollbar.style.setProperty('--scroll-thumb-offset', `${progress * travel}px`);
        };
        updateScrollbar = () => {
          if (frame === null) frame = requestAnimationFrame(renderScrollbar);
        };
        scroll.setAttribute('data-custom-scrollbar', '');
        scroll.addEventListener('scroll', updateScrollbar, { ...options, passive: true });
        window.addEventListener('resize', updateScrollbar, options);
        const observer = new ResizeObserver(updateScrollbar);
        observer.observe(scroll);
        if (scroll.firstElementChild) observer.observe(scroll.firstElementChild);
        this.stopScrollbar = () => {
          observer.disconnect();
          if (frame !== null) cancelAnimationFrame(frame);
          scroll.removeAttribute('data-custom-scrollbar');
        };
      }
      const records = Array.from(dialog.querySelectorAll('.bf-lucky-draw__record'));
      const list = dialog.querySelector('.bf-lucky-draw__records-list');
      const viewport = dialog.querySelector('.bf-lucky-draw__records-viewport');
      let animation = null;
      const group = dialog.querySelector('.bf-lucky-draw__records');
      const interval = Math.max(1000, Number(group?.dataset.interval) || 2000);
      let firstRecord = 0;
      let paused = group?.dataset.autoplay === 'false';
      let focused = false;
      let timer = null;
      const pageSize = () => 3;
      const recordGap = () => list ? parseFloat(window.getComputedStyle?.(list).rowGap) || 0 : 0;
      const stop = () => { clearInterval(timer); timer = null; if (animation) { animation.onfinish = null; animation.cancel(); animation = null; renderRecords(); } };
      this.stopRotation = stop;
      const renderRecords = () => {
        if (!group) return;
        records.forEach((record, index) => {
          const position = (index - firstRecord + records.length) % records.length;
          record.hidden = position >= pageSize();
          record.style.order = String(position);
        });
        if (viewport && dialog.open) {
          const visibleRecords = records.filter(record => !record.hidden);
          const height = visibleRecords.reduce((sum, record) => sum + record.getBoundingClientRect().height, 0) + Math.max(0, visibleRecords.length - 1) * recordGap();
          if (height) viewport.style.height = `${height}px`;
        }
      };
      const advance = () => {
        const finish = () => {
          firstRecord = (firstRecord + 1) % records.length;
          renderRecords();
        };
        if (!list?.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return; }
        const distance = records[firstRecord].getBoundingClientRect().height + recordGap();
        const entering = records[(firstRecord + pageSize()) % records.length];
        entering.hidden = false;
        entering.style.order = String(pageSize());
        animation = list.animate([{ transform: 'translateY(0)' }, { transform: `translateY(-${distance}px)` }], {
          duration: interval, easing: 'linear', fill: 'forwards',
        });
        animation.onfinish = () => {
          const completed = animation;
          animation = null;
          finish();
          completed.cancel();
          if (dialog.open && !document.hidden && !paused && !focused) advance();
        };
      };
      const schedule = () => {
        stop();
        if (!dialog.open || document.hidden || paused || focused || records.length <= pageSize()) return;
        if (list?.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) advance();
        else timer = setInterval(advance, interval);
      };
      if (group) {
        group.addEventListener('focusin', () => { focused = true; schedule(); }, options);
        group.addEventListener('focusout', (event) => { focused = group.contains(event.relatedTarget); schedule(); }, options);
        document.addEventListener('visibilitychange', schedule, options);
        window.addEventListener('resize', () => { stop(); renderRecords(); schedule(); }, options);
      }
      renderRecords();
      const open = () => {
        if (!dialog.open) dialog.showModal();
        updateScrollbar();
        renderRecords();
        schedule();
      };
      trigger.addEventListener('click', open, options);
      this.querySelector('.bf-lucky-draw__terms-close').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
          dialog.close();
        }
      }, options);
      dialog.addEventListener('close', () => { stop(); focused = false; trigger.focus({ preventScroll: true }); }, options);
      this.closest('.shopify-section')?.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('.bf-lucky-draw__term, .bf-lucky-draw__terms-grid, .bf-lucky-draw__record, .bf-lucky-draw__records');
        if (!block || !dialog.contains(block)) return;
        const recordIndex = records.indexOf(block);
        if (recordIndex >= 0) { firstRecord = recordIndex; paused = true; }
        open();
        if (!group) block.scrollIntoView({ block: 'nearest' });
      }, options);
    }

    disconnectedCallback() {
      this.stopScrollbar?.();
      this.stopRotation?.();
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
